const state = {
  channelUpdate: '',
  tempList: [],
}

const mutations = {
  CHANNEL_UPDATED (state, payload) {
    state.channelUpdate = payload
  },
  ADD_TO_TEMP_LIST (state, payload) {
    state.tempList.push(payload)
  },
  REMOVE_FROM_TEMP_LIST (state, payload) {
    state.tempList.splice(payload, 1)
  },
  CLEAR_TEMP_LIST (state, payload) {
    state.tempList = state.tempList.filter(e => e.consumer_loan_id !== payload)
  },
}

const actions = {
  channelUpdated ({ state, commit }) {
    commit('CHANNEL_UPDATED', new Date().getTime())
  },
  addToTempList ({ commit }, payload) {
    commit('ADD_TO_TEMP_LIST', payload)
  },
  removeFromTempList ({ state, commit }, index) {
    commit('REMOVE_FROM_TEMP_LIST', index)
  },
  clearTempList ({ commit }, consumerLoanId) {
    commit('CLEAR_TEMP_LIST', consumerLoanId)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  strict: true,
}
